<template>
  <div class="wrap">
    <div class="header">
      <div class="selinput">
        <van-field
          center
          :value="val"
          is-link
          readonly
          label="热门品种："
          placeholder="请选择热门品种"
          @click="onClickHot"
        />
      </div>
      <van-button
        @click="tabBtn('0')"
        :color="type == 0 ? 'linear-gradient(to right, #4bb0ff, #6149f6)' : ''"
        size="small"
      >
        盘口数据
      </van-button>
      <van-button
        @click="tabBtn('1')"
        :color="type == 1 ? 'linear-gradient(to right, #4bb0ff, #6149f6)' : ''"
        size="small"
      >
        价格走势
      </van-button>
    </div>
    <van-notice-bar
      v-if="sellPostNum"
      scrollable
      background="#fff"
      left-icon="volume-o"
      :text="
        `今日${postType == 2 ? '出售' : postType == 1 ? '求购' : '成交'}帖子总数量: ${
          postType == 2 ? sellPostNum : postType == 1 ? buyPostNum : dealPostNum
        } ~`
      "
    ></van-notice-bar>

    <div v-if="type == 0" class="list">
      <div class="row">
        <div class="itemfirst"></div>
        <div class="item">品种</div>
        <div class="item">价格(元)</div>
        <div class="item">数量</div>
        <!-- <div style="flex:2" class="item">发帖人</div> -->
        <div class="item">时间</div>
      </div>
      <div class="row" v-for="(item, index) in list" @click="back(item)" :key="index">
        <div class="itemfirst">
          <!-- <span class="itemInline">{{ index + 1 }}</span> -->
          <!-- <img v-if="postType == '2'" class="fixedtop" src="../../assets/img/cs.png" alt="" /> -->

          <span style="background: #2A82E4;" v-if="postType == '2'" class="tipbox">
            卖
          </span>
          <span style="background: #43CF7C;" v-if="postType == '1'" class="tipbox">
            买
          </span>
          <span style="background: #FF8D1A;" v-if="postType == '3'" class="tipbox">
            成
          </span>
          <!-- <img v-if="postType == '1'" class="fixedtop" src="../../assets/img/qg.png" alt="" /> -->
          <!-- <img v-if="postType == '3'" class="fixedtop" src="../../assets/img/cj.png" alt="" /> -->
        </div>
        <div class="item">{{ val }}</div>
        <div class="item">{{ twoFixed(item.price) }}</div>
        <div v-if="item.num > 0" class="item">{{ item.num }} {{ item.unit }}</div>
        <div v-else style="color:#2A82E4" class="item">详情</div>
        <!-- <div style="flex:2" class="item">
     
          <span class="s">{{ item.postAuthor }}</span>
        </div> -->
        <div v-if="item.postPublishTime" style="font-size: 13px;" class="item">
          {{ setTimeDays(item.postPublishTime) }}
        </div>
        <div v-else class="item">\</div>
      </div>
      <div v-if="val == '京剧'" class="allcount">
        实时{{ postType == 1 ? '买盘' : postType == 2 ? '卖盘' : '成交' }}数量共：{{ allcount }}枚
      </div>
    </div>

    <div v-if="type == 0" class="bottombtn">
      <van-button
        block
        :color="postType == 1 ? 'linear-gradient(to right, #4bb0ff, #6149f6)' : ''"
        @click="seltab('1', '买')"
        size="small"
        class="btn"
      >
        买盘
      </van-button>
      <van-button
        block
        :color="postType == 2 ? 'linear-gradient(to right, #4bb0ff, #6149f6)' : ''"
        @click="seltab('2', '卖')"
        size="small"
        class="btn"
      >
        卖盘
      </van-button>
      <van-button
        block
        :color="postType == 3 ? 'linear-gradient(to right, #4bb0ff, #6149f6)' : ''"
        @click="seltab('3', '成交')"
        size="small"
        class="btn"
      >
        成交
      </van-button>
    </div>

    <div v-if="type == 1" class="echarts">
      <echarts-component
        class="ma-auto"
        :echarStyle="{ width: '360px', height: '300px', margin: '0 auto' }"
        echartId="echarts"
        echartRef="echarts"
        :echartsdatas="echartsOption"
        ref="echarts"
      ></echarts-component>
    </div>

    <div v-if="type == 1" class="selDate">
      <div class="left">
        <van-button
          class="btn"
          @click="changeTime('2')"
          :color="timeType == 2 ? 'linear-gradient(to right, #4bb0ff, #6149f6)' : ''"
          size="small"
        >
          日
        </van-button>
        <van-button
          class="btn"
          @click="changeTime('1')"
          :color="timeType == 1 ? 'linear-gradient(to right, #4bb0ff, #6149f6)' : ''"
          size="small"
          >周</van-button
        >
        <van-button
          class="btn"
          @click="changeTime('0')"
          :color="timeType == 0 ? 'linear-gradient(to right, #4bb0ff, #6149f6)' : ''"
          size="small"
          >月</van-button
        >
      </div>
      <div class="right">
        <van-button
          class="btn"
          :color="type == 1 ? 'linear-gradient(to right, #4bb0ff, #6149f6)' : ''"
          size="small"
        >
          <img src="../../assets/img/aczx.png" alt="" />
        </van-button>
      </div>
    </div>

    <van-picker
      class="fixed"
      :show-toolbar="true"
      title="热门品种"
      value-key="varietyName"
      v-if="showPicker"
      :columns="columns"
      @confirm="confirm"
      @cancel="cancel"
    ></van-picker>
  </div>
</template>

<script>
import { gethotLexicon, getQueryPrice, getHotPrice } from '@/api/base';
import { setTimeDays, twoFixed, replaceKeys } from '@/utils/index';
import echartsComponent from '../components/echarts.vue';

const waterMarkText = '一尘盯盘助手';

const canvas = document.createElement('canvas');

const ctx = canvas.getContext('2d');

canvas.width = canvas.height = 100;

ctx.textAlign = 'center';

ctx.textBaseline = 'middle';

ctx.globalAlpha = 0.08;

ctx.font = '15px Microsoft Yahei';

ctx.translate(50, 50);

ctx.rotate(-Math.PI / 4);

ctx.fillText(waterMarkText, 0, 0);

export default {
  components: { echartsComponent },
  data() {
    return {
      val: '',
      varietyId: null,
      allcount: null,
      sellPostNum: null,
      hotList: [],
      list: [],
      statuText: '买',
      dealPostNum: null,
      buyPostNum: null,
      type: 0, // 0盘口数据  1价格走势
      postType: 1,
      ec2: {
        lazyLoad: true,
      },
      showPicker: false,
      columns: [],
      timeType: 2, //0 按月查询 1 按周查询 2 按日查询 3自定义时间区间
      maxPrice: null,
      minPrice: null,
      echartsOption: {
        backgroundColor: {
          //在背景属性中添加
          type: 'pattern',
          image: canvas,
          repeat: 'repeat',
        },
        xAxis: {
          type: 'time',
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
            },
          },
        },
        yAxis: {
          type: 'value',
          minInterval: 1,
          // maxInterval: 1,
          // interval: 1,
          min: null,
          max: null,
          // scale: true,
          // boundaryGap: [0, '100%'],
          axisLabel: {
            formatter: '{value} 元',
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
            },
          },
        },
        grid: {
          top: '8%',
          left: '18%',
          right: '10%',
          bottom: '15%',
        },
        tooltip: {
          trigger: 'axis', //坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'line', // 默认为直线，可选为：'line' | 'swhado'
          },
        },
        series: [
          {
            name: '价格',
            type: 'line',
            // showSymbol: false,
            // smooth: true,
            // clip: true,
            itemStyle: {
              color: '#6149f6',
            },
            label: {
              show: true,
              overflow: 'break',
              position: 'top',
              textStyle: { fontSize: 10 },
            },
            labelLayout: {
              hideOverlap: true,
            },
            data: [],
          },
        ],
      },
    };
  },
  computed: {
    isVip() {
      let userInfo = this.$store.state.app.userinfos;
      if (userInfo && userInfo.vipExpireTime && userInfo.isVip == 1) {
        return true;
      }
      return false;
    },
  },
  created() {
    this.init();
  },
  methods: {
    setTimeDays,
    twoFixed,
    replaceKeys,
    getCount() {
      let num = 0;
      this.list.map(item => {
        console.log(this.getNumbers(item));
        num = Number(num) + Number(this.getNumbers(item));
        console.log('累计=', num);
      });
      this.allcount = num;
    },
    getNumbers(item) {
      if (item.unit == '枚') {
        return item.num;
      } else if (item.unit == '盒') {
        return Number(item.num) * 100;
      } else if (item.unit == '卷') {
        return Number(item.num) * 20;
      } else {
        return 0;
      }
    },
    init() {
      gethotLexicon().then(res => {
        this.val = res.data[0].varietyName;
        this.varietyId = res.data[0].id;
        this.echartsOption.yAxis.min = res.data[0].minPrice;
        this.echartsOption.yAxis.max = res.data[0].maxPrice;
        this.columns = res.data;
        this.val = this.val;
        this.varietyId = this.varietyId;
        this.sellPostNum = res.data[0].sellPostNum;
        this.buyPostNum = res.data[0].buyPostNum;
        this.dealPostNum = res.data[0].dealPostNum;

        console.log(this.isVip);
        // if (!this.isVip) {
        //   this.overlayShow = true;
        //   this.$dialog
        //     .alert({
        //       message: '暂未开通会员',
        //       theme: 'round-button',
        //       confirmButtonText: '开通会员',
        //     })
        //     .then(() => {
        //       this.$router.push({ path: '/vip' });
        //     });
        // } else {
        //   this.gethotList();
        // }
        this.gethotList();
      });
    },
    gethotList() {
      getHotPrice({ size: 15, postType: this.postType, varietyId: this.varietyId }).then(res => {
        if (this.postType == 1) {
          this.list = res.data.records.sort((a, b) => b.price - a.price);
        } else if (this.postType == 2) {
          this.list = res.data.records.sort((a, b) => a.price - b.price);
        } else {
          this.list = res.data.records;
        }
        this.getCount();
      });
    },
    seltab(type, name) {
      this.statuText = name;
      this.postType = type;
      // this.allcount = null;
      this.gethotList();
    },
    tabBtn(e) {
      this.type = Number(e);
      if (e == 1) {
        this.getEchartData();
      }
    },
    onClickHot() {
      this.showPicker = true;
    },
    confirm(picker, value, index) {
      this.echartsOption.yAxis.min = picker.minPrice;
      this.echartsOption.yAxis.max = picker.maxPrice;
      this.val = picker.varietyName;
      this.varietyId = picker.id;
      this.sellPostNum = picker.sellPostNum;
      this.buyPostNum = picker.buyPostNum;
      this.dealPostNum = picker.dealPostNum;
      this.showPicker = false;

      this.gethotList();
    },
    cancel() {
      this.showPicker = false;
    },
    getEchartData() {
      getQueryPrice({ timeType: this.timeType, varietyId: this.varietyId }).then(res => {
        let arr = [];
        let data = res.data;
        data.map(item => {
          arr.push([item.createTime, item.price]);
        });
        this.echartsOption.series[0].data = arr;
        this.$refs.echarts.setOption(this.echartsOption);
      });
    },
    changeTime(e) {
      this.timeType = Number(e);
      this.getEchartData();
    },
    back(item) {
      // 判断机型 ios/安卓
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      const el = isiOS ? document.documentElement : document.body;

      this.$route.meta.scrollHeight = el.scrollTop || el.scrollHeight;
      if (isiOS) {
        window.location.href = `${item.postUrl}`;
      } else {
        this.$router.push({
          path: '/posts',
          query: { title: item.postTitle, src: item.postUrl },
        });
      }
    },
  },
  mounted() {
    setTimeout(function() {
      wx.ready(function() {
        wx.updateAppMessageShareData({
          title: '京剧纪念币盘口走势', // 分享标题
          desc: '公众号[一尘盯盘助手]', // 分享描述
          link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: 'https://ui.smartrecorder.xyz/image/ycIcon.jpg', // 分享图标
          success: function() {
            // 设置成功
          },
        });
        wx.updateTimelineShareData({
          title: '京剧纪念币盘口走势', // 分享标题
          desc: '公众号[一尘盯盘助手]', // 分享描述
          link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: 'https://ui.smartrecorder.xyz/image/ycIcon.jpg', // 分享图标
          success: function() {
            // 设置成功
          },
        });
      });
    }, 1000);
  },
};
</script>
<style scoped>
.wrap {
  font-size: 16px;
  padding: 0 15px;
  box-sizing: border-box;
  background: #f8f8f8;
}
.header {
  display: flex;
  align-items: center;
  background: #fff;
  margin-bottom: 10px;
}
.selinput {
  flex: 1;
}
.row {
  display: flex;
  background: #fff;
  border-bottom: 1px solid #eee;
}
.row:first-child {
  border-bottom: 1px solid #eee;
}
.list {
  background: #fff;
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 42px;
}
.row .item {
  flex: 1;
  text-align: center;
  font-size: 16px;
  line-height: 35px;
  position: relative;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.row .item .s {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.row .itemfirst {
  width: 42px;
  padding-left: 18px;
  line-height: 35px;
  text-align: center;
  font-size: 12px;
  position: relative;
}
.row .itemfirst .tipbox {
  background: red;
  padding: 3px;
  color: #fff;
}
.row .itemlastTH {
  line-height: 35px;
}
.row .itemlast {
  width: 90px;
  /* line-height: 70rpx; */
  text-align: center;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.row .row:last-child {
  border: none;
}
.bottombtn {
  display: flex;
  padding: 0 20px;
  margin-top: 10px;
  position: fixed;
  bottom: 10px;
  left: 0;
  right: 0;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
.bottombtn .btn {
  flex: 1;
}
.bottombtn .btn:first-child {
  margin-right: 5px;
}
.bottombtn .btn:last-child {
  margin-left: 5px;
}
.itemfirst .itemInline {
  position: relative;
  /* padding-left: 25px; */
}
.itemfirst .fixedtop {
  position: absolute;
  left: 5px;
  top: -5px;
  font-size: 8px;
  color: red;
  width: 34px;
  /* transform:rotate(-10deg); */
}

.echarts {
  width: 100%;
  margin: 0 auto;
  height: 300px;
  background: #fff;
  border-radius: 5px;
  overflow: hidden;
}
ec-canvascanvas {
  width: 100%;
  height: 100%;
}
.selDate {
  display: flex;
  justify-content: space-between;
  background: #fff;
  margin-top: 10px;
  padding: 10px;
  border-radius: 5px;
  overflow: hidden;
}
.selDate .left .btn {
  margin-left: 5px;
}
.selDate .right .btn img {
  width: 20px;
  height: 20px;
}

.fixed {
  position: fixed;
  z-index: 9;
  bottom: 0;
  left: 0;
  right: 0;
}
.allcount {
  font-size: 18px;
  margin: 10px;
  text-align: center;
  font-weight: bold;
}
</style>
